import { useState } from "react";
import { Box } from "@mui/material";
import {
  ClipLoader,
  CircleLoader as CL,
  HashLoader as CircleLoader,
} from "react-spinners";
import Backdrop from "../modal/Backdrop";
function CircleLoad({ loading, color, size = 150 }) {
  return (
    <Backdrop open={loading}>
      <Box>
        <CircleLoader
          color={color}
          loading={loading}
          // cssOverride={override}
          size={size || 150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </Box>
    </Backdrop>
  );
}

export default CircleLoad;
